import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { queryClient } from '@hooks/queryClient';
import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  setRequestedBy?: boolean;
}

export const useGenerateBatchReport = () => {
  return useMutation({
    mutationFn: async ({ batchId, setRequestedBy }: HookProps) => {
      const result = await apiClient.batchesReports.batchReport.mutation({ body: { batchId, setRequestedBy } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
